var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('label',{class:_vm.getClass,attrs:{"title":_vm.title},on:{"click":_vm.onFill}},[(_vm.applyCurrencyFormat)?_c('div',[_vm._v(_vm._s(_vm._f("currency")(_vm.fillableValue)))]):_c('div',[_vm._v(_vm._s(_vm.fillableValue))])])])}
var staticRenderFns = []

export { render, staticRenderFns }